(function(){
    angular
        .module('maApp.view.partials')
        .controller('LogoutController',LogoutController);

    LogoutController.$inject = ['$scope', 'Auth'];

    function LogoutController($scope, Auth) {
        $scope.title = "Logout";
        Auth.unsetUserAuthData();
        window.location.href =  'http://' + window.location.host + '/apps/authentication/pb_logout.php?app=IWMM&returnURL=http%3A%2F%2Fdata.pointblue.org%2Fpartners%2Fiwmm%2F';
    }

})();